/* Ausgelagert aus sections/ext-main-product.liquid.
   Die beiden Liquid-Werte (Section-ID und Variantenliste) kommen aus dem
   JSON-Block "ExtMainProductData" im Markup der Section. */
document.addEventListener("DOMContentLoaded", function() {
  const dataEl = document.querySelector('script[type="application/json"][data-ext-main-product]');
  if (!dataEl) return;
  const extData = JSON.parse(dataEl.textContent);
  const sectionId = extData.sectionId;
  const track = document.getElementById("MainGalleryTrack-" + sectionId);
  const dotsContainer = document.getElementById("MainGalleryDots-" + sectionId);
  const dots = dotsContainer ? dotsContainer.querySelectorAll(".ext-gallery-dot") : [];
  const thumbTrack = document.getElementById("MainGalleryThumbs-" + sectionId);
  const thumbs = document.querySelectorAll(".ext-thumb-btn");
  const stickyCol = document.getElementById("StickyMediaCol-" + sectionId);
  const originalPriceContainer = document.getElementById("Price-" + sectionId);
  const btnPrev = document.getElementById("ThumbPrev-" + sectionId);
  const btnNext = document.getElementById("ThumbNext-" + sectionId);
  let tibXLockActive = false;
  let tibXLockRafId = null;
  let lastVerticalScrollY = window.scrollY;
  let lastVerticalScrollTs = 0;

  // Zuletzt gemessene Hoehe der Medienspalte, waehrend sie oben klebt
  // (geschrumpftes Bild + eingeblendete Preis-/Trust-Leiste). Die sticky
  // Kaufleiste braucht diesen Wert, um beim Sprung zurueck zum
  // Konfigurator vorherzusagen, wie viel Platz die Spalte gleich wieder
  // oben belegen wird - im Moment des Klicks klebt sie ja noch nicht.
  let lastStuckColHeight = 0;

  // --- ZENTRALER BREITEN-WATCHER ---
  // Reine Hoehenaenderungen (iOS-Adressleiste beim Scrollen) feuern staendig
  // resize-Events und duerfen keine Layout-Neuberechnung ausloesen.
  const widthChangeHandlers = [];
  function onWidthChange(fn) { widthChangeHandlers.push(fn); }
  (function () {
    let lastWidth = window.innerWidth;
    let timer = null;

    function run() {
      timer = null;
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      widthChangeHandlers.forEach(function (fn) {
        try { fn(); } catch (e) { console.error('[EXT] Breiten-Handler fehlgeschlagen', e); }
      });
    }

    function schedule() {
      if (timer) clearTimeout(timer);
      // Waehrend des Ziehens am Fensterrand feuert resize dutzendfach.
      timer = setTimeout(run, 120);
    }

    window.addEventListener('resize', schedule);
    // iOS meldet die neuen Masse nach einer Drehung erst nach dem Event.
    window.addEventListener('orientationchange', function () { setTimeout(schedule, 250); });
  })();

  // Die Inline-Hoehe von #tee-gallery ist der Scrollraum, den TeeInBlue selbst
  // setzt. Das Sticky-Shrinking ueberschreibt ihn kurzzeitig - ohne
  // Sicherungskopie waere er danach dauerhaft weg und die Medienspalte fiele
  // auf Bildhoehe zusammen.
  let tibSpacerHeight = '';
  function rememberTibSpacerHeight(el) {
    if (!el || el.style.getPropertyPriority('height') === 'important') return;
    const value = el.style.getPropertyValue('height');
    if (value) tibSpacerHeight = value;
  }
  function restoreTibSpacerHeight(el) {
    if (!el) return;
    const isImportant = el.style.getPropertyPriority('height') === 'important';
    if (!isImportant && el.style.getPropertyValue('height') === tibSpacerHeight) return;
    el.style.removeProperty('height');
    if (tibSpacerHeight) el.style.setProperty('height', tibSpacerHeight);
  }

  // --- TEEINBLUE-GALERIE AN DIE NEUE BREITE ANPASSEN ---
  // TeeInBlue rendert Slider, Mockup und alle Druckflaechen einmalig in
  // festen Pixeln und rechnet bei Resize/Drehung nicht nach. Ohne Korrektur
  // behaelt das Bild die Groesse vom Seitenaufbau: es fuellt die Spalte nicht
  // mehr aus und sitzt nicht mehr mittig. Die komplette Innengeometrie ist
  // proportional zur Mockup-Breite, ein gleichmaessiges scale() liefert daher
  // exakt dasselbe Ergebnis wie ein Neuaufbau durch TeeInBlue.
  // TeeInBlue haelt im Slider fuer jedes Motiv ein eigenes Mockup vor, blendet
  // aber alle bis auf das aktive per display:none aus - die messen dann 0.
  // Zusaetzlich bringt die Thumbnail-Leiste eigene Mini-Mockups (80px) mit.
  // Beides darf weder als Bezugsgroesse dienen noch mitskaliert werden, sonst
  // werden die Vorschaubilder um ein Vielfaches vergroessert.
  function sliderMockups(root) {
    if (!root) return [];
    return Array.prototype.filter.call(root.querySelectorAll('.tee-mockup'), (m) => !m.closest('.tee-thumbnails'));
  }

  function sichtbaresMockup(root) {
    const alle = sliderMockups(root);
    return alle.find((m) => m.offsetWidth > 0) || alle[0] || null;
  }

  // offsetWidth/offsetHeight sind die Layoutmasse und ignorieren transform.
  // Stehen sie auf 0, rechnet der Browser diesen Teilbaum gerade nicht aus:
  // TeeInBlue baut die Galerie neu auf, das Motiv wechselt gerade, oder die
  // Seite ist noch im Aufbau. Jede Messung ist dann wertlos - und ein daraus
  // abgeleiteter Massstab schrumpft das Bild dauerhaft.
  function messbar(el) {
    return !!el && el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  // Zwischen Bild und Vorschauflaeche darf kein zweites scale() stehen: es
  // multipliziert sich mit unserem, und offsetWidth (die Rechengrundlage)
  // merkt davon nichts. Nur reine scale()-Angaben werden entfernt - ein
  // translate() vom Karussell muss stehen bleiben.
  function loeseFremdeSkalierung(el, bis) {
    let p = el && el.parentElement;
    while (p && p !== bis) {
      if (/^scale\(/.test(p.style.transform)) p.style.transform = '';
      p = p.parentElement;
    }
  }

  function syncTibGalleryToWidth(updateSpacer) {
    const content = document.querySelector('#tee-gallery, .tee-gallery-content');
    if (!content) return;

    const sliders = content.querySelectorAll('.tee-slider');
    if (!sliders.length) return;

    const available = Math.round(content.clientWidth);
    if (!available) return;

    // Die Slider bekamen hier frueher eine quadratische Hoehe. Das stimmt nur,
    // solange das Mockup quadratisch ist - nach einem Produktwechsel (Poster
    // auf Leinwand) hat es ein anderes Seitenverhaeltnis, und unter dem
    // flacheren Bild blieb der Rest des Quadrats als weisse Luecke stehen.
    const bezug = sichtbaresMockup(content);
    const sliderHoehe = messbar(bezug)
      ? Math.round(available * (bezug.offsetHeight / bezug.offsetWidth))
      : available;

    sliders.forEach((slider) => {
      if (slider.style.width !== available + 'px') slider.style.width = available + 'px';
      if (slider.style.height !== sliderHoehe + 'px') slider.style.height = sliderHoehe + 'px';
    });

    sliderMockups(content).forEach((mockup) => {
      // offsetWidth ignoriert transform und liefert daher immer die
      // urspruengliche Rendergroesse als Bezug.
      const base = mockup.offsetWidth;
      if (!base) return;
      const value = 'scale(' + (Math.round((available / base) * 1000) / 1000) + ')';
      loeseFremdeSkalierung(mockup, content);
      if (mockup.style.transformOrigin !== 'center center') mockup.style.transformOrigin = 'center center';
      if (mockup.style.transform !== value) mockup.style.transform = value;
    });

    // Die Hoehe von #tee-gallery ist der Scrollraum der sticky Galerie und
    // haengt an der Formularhoehe - die aendert sich mit der Breite mit. Nur
    // beim echten Breitenwechsel nachziehen (beim Seitenaufbau steht die
    // Formularhoehe noch gar nicht fest) und nur im Desktop-Layout, wo sich
    // die Regel exakt mit dem deckt, was TeeInBlue selbst setzt.
    if (updateSpacer && window.innerWidth >= 990) {
      const form = document.getElementById('teeinblue-form');
      const target = Math.max(form ? Math.round(form.offsetHeight) : 0, available);
      if (target > 0) {
        tibSpacerHeight = target + 'px';
        if (content.style.height !== tibSpacerHeight) content.style.height = tibSpacerHeight;
      }
    }
  }

  function enforceTibHorizontalScrollLock() {
    if (!tibXLockActive) return;

    // Vertikales Scrollen registrieren. Auf iOS wuerde ein
    // window.scrollTo() waehrend eines laufenden Momentum-Scrolls das
    // Scrollen hart abbrechen - fuer den Nutzer fuehlt sich das an, als
    // wuerde die Seite "zurueckspringen". Deshalb korrigieren wir den
    // horizontalen Versatz nur, wenn gerade NICHT vertikal gescrollt wird.
    if (Math.abs(window.scrollY - lastVerticalScrollY) > 1) {
      lastVerticalScrollY = window.scrollY;
      lastVerticalScrollTs = Date.now();
      return;
    }

    // Erst ab spuerbarem Versatz eingreifen (Rubberband auf iOS erzeugt
    // staendig winzige Werte).
    if (Math.abs(window.scrollX) < 4) return;
    if (Date.now() - lastVerticalScrollTs < 250) return;
    if (tibXLockRafId !== null) return;
    tibXLockRafId = requestAnimationFrame(() => {
      tibXLockRafId = null;
      if (!tibXLockActive) return;
      if (Math.abs(window.scrollY - lastVerticalScrollY) > 1) return;
      if (Math.abs(window.scrollX) >= 4) {
        window.scrollTo(0, window.scrollY);
      }
    });
  }

  function syncTibHorizontalScrollLock() {
    const hasTeeInBlue = document.body.classList.contains('teeinblue-enabled') || !!document.querySelector('#teeinblue-form');
    const next = hasTeeInBlue && window.innerWidth < 990;
    if (next === tibXLockActive) return;
    tibXLockActive = next;
    document.documentElement.classList.toggle('ext-tib-lock-x', tibXLockActive);
    document.body.classList.toggle('ext-tib-lock-x', tibXLockActive);
    if (!tibXLockActive) {
      document.documentElement.classList.remove('ext-tib-no-x-scroll');
      document.body.classList.remove('ext-tib-no-x-scroll');
    }
  }

  syncTibHorizontalScrollLock();
  // TeeInBlue wird asynchron gemountet - deshalb kurz nachpollen, statt
  // wie frueher auf (haeufige, aber unzuverlaessige) resize-Events zu warten.
  let tibXLockTries = 0;
  const tibXLockTimer = setInterval(function () {
    tibXLockTries += 1;
    syncTibHorizontalScrollLock();
    if (tibXLockActive || tibXLockTries >= 40) clearInterval(tibXLockTimer);
  }, 300);
  document.addEventListener('teeinblue-component-loaded', syncTibHorizontalScrollLock);
  onWidthChange(syncTibHorizontalScrollLock);
  window.addEventListener('scroll', enforceTibHorizontalScrollLock, { passive: true });

  function normalizeNonFrameColorSwatches() {
    const form = document.getElementById('teeinblue-form');
    if (!form) return false;

    const colorOptions = form.querySelectorAll('.tee-option--color:not(.custom-frame-wrapper)');
    if (!colorOptions.length) return false;

    const clearCircleInlineStyles = (row, radio, label, swatch) => {
      if (row) {
        row.style.removeProperty('display');
        row.style.removeProperty('flex-wrap');
        row.style.removeProperty('align-items');
        row.style.removeProperty('gap');
      }

      radio.style.removeProperty('width');
      radio.style.removeProperty('height');
      radio.style.removeProperty('min-width');
      radio.style.removeProperty('min-height');
      radio.style.removeProperty('padding');
      radio.style.removeProperty('margin');
      radio.style.removeProperty('border');
      radio.style.removeProperty('background');
      radio.style.removeProperty('box-shadow');

      if (label) {
        label.style.removeProperty('width');
        label.style.removeProperty('height');
        label.style.removeProperty('min-width');
        label.style.removeProperty('min-height');
        label.style.removeProperty('display');
        label.style.removeProperty('align-items');
        label.style.removeProperty('justify-content');
        label.style.removeProperty('padding');
        label.style.removeProperty('margin');
        label.style.removeProperty('position');
        label.style.removeProperty('font-size');
        label.style.removeProperty('line-height');
        label.style.removeProperty('border-radius');
        label.style.removeProperty('box-sizing');
        label.style.removeProperty('overflow');
        label.style.removeProperty('background');
        label.style.removeProperty('border');
        label.style.removeProperty('box-shadow');
      }

      if (swatch) {
        swatch.style.removeProperty('width');
        swatch.style.removeProperty('height');
        swatch.style.removeProperty('min-width');
        swatch.style.removeProperty('min-height');
        swatch.style.removeProperty('position');
        swatch.style.removeProperty('inset');
        swatch.style.removeProperty('display');
        swatch.style.removeProperty('margin');
        swatch.style.removeProperty('padding');
        swatch.style.removeProperty('font-size');
        swatch.style.removeProperty('line-height');
        swatch.style.removeProperty('border-radius');
        swatch.style.removeProperty('border');
        swatch.style.removeProperty('box-shadow');
      }
    };

    colorOptions.forEach((option) => {
      const row = option.querySelector('.tee-option-inner');
      const radios = Array.from(option.querySelectorAll('.tee-radio'));
      const hasAnySwatch = radios.some((radio) => !!radio.querySelector('.tee-swatch--color'));

      if (!hasAnySwatch) {
        option.classList.remove('ext-color-has-swatches');
        radios.forEach((radio) => {
          radio.classList.remove('ext-color-selected');
          const label = radio.querySelector('.tee-radio-label') || radio.querySelector('label');
          const swatch = radio.querySelector('.tee-swatch--color');
          clearCircleInlineStyles(row, radio, label, swatch);
        });
        return;
      }

      option.classList.add('ext-color-has-swatches');

      if (row) {
        row.style.setProperty('display', 'flex', 'important');
        row.style.setProperty('flex-wrap', 'wrap', 'important');
        row.style.setProperty('align-items', 'center', 'important');
        row.style.setProperty('gap', '10px', 'important');
      }

      let selectedRadio = null;
      const checkedInput = option.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        selectedRadio = checkedInput.closest('.tee-radio');
      }
      if (!selectedRadio) {
        selectedRadio = option.querySelector('.tee-radio.active') || null;
      }

      radios.forEach((radio) => {
        radio.classList.remove('ext-color-selected');
        const input = radio.querySelector('input[type="radio"]');
        const label = radio.querySelector('.tee-radio-label') || radio.querySelector('label');
        const swatch = radio.querySelector('.tee-swatch--color');
        if (!label || !swatch) return;

        radio.style.setProperty('width', '34px', 'important');
        radio.style.setProperty('height', '34px', 'important');
        radio.style.setProperty('min-width', '34px', 'important');
        radio.style.setProperty('min-height', '34px', 'important');
        radio.style.setProperty('padding', '0', 'important');
        radio.style.setProperty('margin', '0', 'important');
        radio.style.setProperty('border', 'none', 'important');
        radio.style.setProperty('background', 'transparent', 'important');
        radio.style.setProperty('box-shadow', 'none', 'important');

        label.style.setProperty('width', '34px', 'important');
        label.style.setProperty('height', '34px', 'important');
        label.style.setProperty('min-width', '34px', 'important');
        label.style.setProperty('min-height', '34px', 'important');
        label.style.setProperty('display', 'flex', 'important');
        label.style.setProperty('align-items', 'center', 'important');
        label.style.setProperty('justify-content', 'center', 'important');
        label.style.setProperty('padding', '0', 'important');
        label.style.setProperty('margin', '0', 'important');
        label.style.setProperty('position', 'relative', 'important');
        label.style.setProperty('font-size', '0', 'important');
        label.style.setProperty('line-height', '0', 'important');
        label.style.setProperty('border-radius', '9999px', 'important');
        label.style.setProperty('box-sizing', 'border-box', 'important');
        label.style.setProperty('overflow', 'hidden', 'important');
        label.style.setProperty('background', 'transparent', 'important');

        swatch.style.setProperty('width', '100%', 'important');
        swatch.style.setProperty('height', '100%', 'important');
        swatch.style.setProperty('min-width', '100%', 'important');
        swatch.style.setProperty('min-height', '100%', 'important');
        swatch.style.setProperty('position', 'absolute', 'important');
        swatch.style.setProperty('inset', '0', 'important');
        swatch.style.setProperty('display', 'block', 'important');
        swatch.style.setProperty('margin', '0', 'important');
        swatch.style.setProperty('padding', '0', 'important');
        swatch.style.setProperty('font-size', '0', 'important');
        swatch.style.setProperty('line-height', '0', 'important');
        swatch.style.setProperty('border-radius', '9999px', 'important');
        swatch.style.setProperty('border', 'none', 'important');
        swatch.style.setProperty('box-shadow', 'none', 'important');

        const isActive = selectedRadio ? radio === selectedRadio : (!!(input && input.checked) || radio.classList.contains('active') || radio.getAttribute('aria-checked') === 'true');
        radio.classList.toggle('active', isActive);
        radio.setAttribute('aria-checked', isActive ? 'true' : 'false');
        if (isActive) {
          radio.classList.add('ext-color-selected');
          label.style.setProperty('border', '2px solid #f59406', 'important');
          label.style.setProperty('background', 'transparent', 'important');
          label.style.setProperty('box-shadow', 'none', 'important');
        } else {
          label.style.setProperty('border', '1px solid #d8dee8', 'important');
          label.style.setProperty('background', 'transparent', 'important');
          label.style.setProperty('box-shadow', 'none', 'important');
        }

        if (!radio.dataset.circleSwatchBound && input) {
          input.addEventListener('change', normalizeNonFrameColorSwatches);
          radio.dataset.circleSwatchBound = '1';
        }
      });
    });

    return true;
  }

  let normalizeSwatchRafId = null;
  let normalizeSwatchVisibilityTimeoutId = null;

  function setColorSwatchesNormalizing(active) {
    const form = document.getElementById('teeinblue-form');
    if (!form) return;
    if (active) {
      form.classList.add('ext-color-normalizing');
      if (normalizeSwatchVisibilityTimeoutId !== null) {
        clearTimeout(normalizeSwatchVisibilityTimeoutId);
      }
      normalizeSwatchVisibilityTimeoutId = setTimeout(() => {
        form.classList.remove('ext-color-normalizing');
        normalizeSwatchVisibilityTimeoutId = null;
      }, 550);
    } else {
      form.classList.remove('ext-color-normalizing');
      if (normalizeSwatchVisibilityTimeoutId !== null) {
        clearTimeout(normalizeSwatchVisibilityTimeoutId);
        normalizeSwatchVisibilityTimeoutId = null;
      }
    }
  }

  function scheduleNormalizeNonFrameColorSwatches() {
    if (normalizeSwatchRafId !== null) {
      cancelAnimationFrame(normalizeSwatchRafId);
    }
    normalizeSwatchRafId = requestAnimationFrame(() => {
      normalizeSwatchRafId = null;
      const ok = normalizeNonFrameColorSwatches();
      if (ok) setColorSwatchesNormalizing(false);
    });
  }

  function scheduleNormalizeNonFrameColorSwatchesBurst() {
    setColorSwatchesNormalizing(true);
    [0, 40, 100, 180, 320].forEach((delay) => {
      setTimeout(() => {
        scheduleNormalizeNonFrameColorSwatches();
      }, delay);
    });
  }

  // --- DER ANTI-ADRESSLEISTEN-TRICK ---
  // Wir frieren die Höhe des Bildschirms beim Laden ein.
  let staticVh = window.innerHeight || document.documentElement.clientHeight;
  // Wenn das Handy gedreht wird (Querformat), müssen wir den Wert updaten.
  // Wir ignorieren reine Höhenänderungen (die durch die Adressleiste kommen).
  onWidthChange(() => {
    staticVh = window.innerHeight || document.documentElement.clientHeight;
  });

  // --- STICKY STATE DETECTION & ROBUST TIB SCALING ---
  // Der Breakpoint wird bewusst NICHT mehr nur beim Laden geprueft: beim
  // Verkleinern des Fensters oder beim Drehen eines Tablets wechselt das
  // Layout, ohne dass die Seite neu geladen wird.
  if(stickyCol) {
    
    let observer = null;
    let isCurrentlyScaling = false;
    let scaleScheduled = null;
    let scaleRunsInWindow = 0;
    let scaleWindowStart = 0;
    let scaleCircuitOpen = false;
    let lastStuckClass = null;
    let lastMetaClass = null;

    // Schreibt nur bei echter Wertaenderung. Jeder blinde Style-Write
    // erzeugt sonst einen MutationRecord -> der MutationObserver unten
    // haengt genau an diesem Element -> Endlosschleife (Container waechst,
    // Seite ruckelt/springt).
    function setImportant(el, prop, value) {
      if (el.style.getPropertyValue(prop) === value && el.style.getPropertyPriority(prop) === 'important') return;
      el.style.setProperty(prop, value, 'important');
    }
    function setPlain(el, prop, value) {
      if (el.style.getPropertyValue(prop) === value) return;
      if (value === '') el.style.removeProperty(prop);
      else el.style.setProperty(prop, value);
    }

    function isMobileStickyLayout() {
      return window.innerWidth < 990;
    }

    // Ohne TeeInBlue soll die Spalte nur solange kleben, wie der eigene
    // Konfigurator laeuft - danach faehrt sie mit nach oben aus dem Bild.
    const releaseBelowSel = stickyCol.dataset.releaseBelow || '';

    function syncStickyRelease() {
      if (!releaseBelowSel) return;
      const anker = document.querySelector(releaseBelowSel);
      if (!anker) return;
      const versatz = Math.min(0, Math.round(anker.getBoundingClientRect().bottom - stickyCol.offsetHeight));
      setPlain(stickyCol, '--ext-sticky-release', versatz + 'px');
    }

    // --- TASTATUR-MODUS MIT ANGEDOCKTEM FELD (nur im Mobil-Layout) ---
    // Bei offener Tastatur bleiben nur noch rund 55% der Bildschirmhoehe
    // uebrig. Die Vorschau behaelt den oberen Teil davon, das Eingabefeld
    // wandert direkt ueber die Tastatur - der Rest des Formulars wird
    // solange ausgeblendet, weil halb sichtbare Felder nur verwirren.
    // Nach dem Antippen dauert es einen Moment, bis die Tastatur oben ist.
    // So lange gilt der Modus auch ohne Bestaetigung durch visualViewport.
    const KEYBOARD_GRACE_MS = 900;
    // Ab dieser sichtbaren Hoehe bleiben Preis und Bewertung waehrend der
    // Eingabe stehen. Darunter braucht die Vorschau den Platz selbst.
    const KEYBOARD_META_MIN_HEIGHT = 460;
    // Seitenrand der angedockten Leiste. Muss inline gesetzt werden, weil
    // TeeInBlue seine eigenen Abstaende aus einem cascade layer heraus setzt.
    const KEYBOARD_DOCK_PADDING = 16;
    const TEXT_FIELD_SELECTOR = 'input[type="text"], input[type="email"], input[type="tel"], input[type="search"], input[type="url"], input:not([type]), textarea';
    // Was beim Tippen als Leiste ueber der Tastatur stehen bleibt: die
    // Beschriftung soll mitkommen, der Rest des Schritts nicht.
    const DOCK_FIELD_SELECTOR = '.tee-field, .paws-extra-wish-wrapper, .paws-upload-content, .paws-text-input-wrapper, .paws-text-line';
    let keyboardField = null;
    let keyboardFocusTime = 0;
    let keyboardTimers = [];
    // Beim Antippen scrollt der Browser selbst zum Feld. Damit der Nutzer nach
    // dem Schliessen der Tastatur wieder an derselben Stelle im Formular steht,
    // merken wir uns, wo das Feld vorher auf dem Bildschirm stand.
    let rueckkehrFeld = null;
    let rueckkehrTop = 0;
    let rueckkehrTimers = [];

    function isTextEntryField(el) {
      if (!el || !el.matches || !el.matches(TEXT_FIELD_SELECTOR)) return false;
      // Nur der Konfigurator, damit z.B. die Suche im Header nichts ausloest.
      if (el.closest('#teeinblue-form, .tee-campaign')) {
        // Die Mengenauswahl ist ein Stepper, kein Textfeld.
        return !el.closest('.tee-quantity-group');
      }
      // Der eigene Konfigurator nur dann, wenn die Vorschau darueber klebt -
      // ohne sie haette der Fokus-Modus nichts, woran er sich ausrichtet.
      return !!(releaseBelowSel && el.closest(releaseBelowSel));
    }

    // Bei offener Tastatur meldet visualViewport die verbleibende Flaeche.
    // Ohne die API (aeltere Browser) mit einem Erfahrungswert weiterrechnen.
    function visibleViewportHeight() {
      const vv = window.visualViewport;
      if (vv && vv.height && vv.height < staticVh - 80) return Math.round(vv.height);
      return Math.round(staticVh * 0.55);
    }

    // Unterkante des sichtbaren Bereichs in denselben Koordinaten wie
    // getBoundingClientRect - auf iOS ist das nicht einfach die Hoehe,
    // weil das Layout-Fenster bei offener Tastatur bestehen bleibt.
    function visibleViewportBottom() {
      const vv = window.visualViewport;
      if (vv && vv.height && vv.height < staticVh - 80) return Math.round(vv.offsetTop + vv.height);
      return Math.round(staticVh * 0.55);
    }

    // Safari verschiebt bei offener Tastatur den sichtbaren Ausschnitt im
    // Layout-Fenster nach unten. sticky und fixed rechnen weiter gegen das
    // Layout-Fenster, getBoundingClientRect misst dagegen bereits gegen den
    // sichtbaren Ausschnitt - der Versatz muss deshalb selbst drauf.
    function viewportOffsetTop() {
      const vv = window.visualViewport;
      return vv ? Math.round(vv.offsetTop) : 0;
    }

    // Ohne das klebt die Vorschau an der Oberkante des Layout-Fensters, die
    // dann oberhalb des Sichtbaren liegt - der Nutzer sieht nur Weiss.
    // Der gesetzte Wert wird gemerkt, weil getBoundingClientRect ihn spaeter
    // wieder mitliefert und die Stuck-Erkennung sonst danebenliegt.
    let stickyTopVersatz = 0;
    function syncStickyTopOffset() {
      const versatz = keyboardField ? viewportOffsetTop() : 0;
      stickyTopVersatz = versatz;
      if (versatz > 0) setImportant(stickyCol, 'top', versatz + 'px');
      else stickyCol.style.removeProperty('top');
    }

    // Im Fokus-Modus soll die Vorschau so gross wie moeglich sein, aber nicht
    // hinter das gedockte Eingabefeld oder die Preisleiste geraten.
    const KEYBOARD_PREVIEW_MAX = 420;
    function keyboardPreviewHeight() {
      const feld = dockedField || (keyboardField && keyboardField.closest(DOCK_FIELD_SELECTOR)) || keyboardField;
      const feldHoehe = feld ? Math.round(feld.getBoundingClientRect().height) : 0;
      const meta = stickyCol.classList.contains('ext-show-sticky-meta') ? stickyCol.querySelector('.ext-sticky-mobile-meta') : null;
      const metaHoehe = meta ? Math.round(meta.getBoundingClientRect().height) : 0;
      return Math.max(120, visibleViewportHeight() - feldHoehe - metaHoehe - 24);
    }

    // Alles zuruecknehmen, was nur im Mobil-Layout gilt.
    function resetStickyState() {
      undockField();
      keyboardField = null;
      stickyTopVersatz = 0;
      stickyCol.style.removeProperty('top');
      stickyCol.classList.remove('ext-keyboard-active');
      document.documentElement.style.removeProperty('--ext-kb-scroll-margin');
      if (lastStuckClass !== false) {
        lastStuckClass = false;
        stickyCol.classList.remove('is-stuck');
      }
      if (lastMetaClass !== false) {
        lastMetaClass = false;
        stickyCol.classList.remove('ext-show-sticky-meta');
      }
      if (releaseBelowSel) stickyCol.style.removeProperty('--ext-sticky-release');
      scaleTeeInBlue(false);
    }

    function scaleTeeInBlue(isStuck) {
      if (isCurrentlyScaling) return;
      // Nicht einfach das erste Mockup nehmen: bei Produkten mit mehreren
      // Motiven steht an erster Stelle ein ausgeblendeter Slide (Groesse 0).
      // Der Massstab kaeme dann aus dem Notwert und das sichtbare Bild wuerde
      // von der Vorschauflaeche abgeschnitten.
      // Nur ein echtes Mockup, kein Ersatzweg auf den Slider-Container: der
      // ist ein VORFAHRE aller spaeteren Mockups (siehe unten).
      const tibContainer = sichtbaresMockup(stickyCol);
      const tibWrapper = stickyCol.querySelector('.tee-gallery-content') || stickyCol.querySelector('#teeinblue-gallery');
      if (!tibContainer || !tibWrapper) return;

      // Lieber gar nichts schreiben als mit geratenen Massen rechnen: der
      // fruehere Notwert von 680px liess das Bild auf die halbe Groesse
      // schrumpfen, waehrend die Flaeche darunter ihre volle Hoehe behielt -
      // genau die Luecke, die Kunden gemeldet haben. Der letzte gute Zustand
      // bleibt stehen; der Groessenwaechter unten holt die Skalierung nach,
      // sobald sich wieder messen laesst.
      if (isStuck && (!messbar(tibContainer) || !tibWrapper.clientWidth)) return;

      isCurrentlyScaling = true;
      try {
        rememberTibSpacerHeight(tibWrapper);
        if (isStuck) {
          const stickyHeightRaw = getComputedStyle(document.getElementById('shopify-section-' + sectionId)).getPropertyValue('--sticky-height-mobile').trim();
          let targetHeight = 300;
          // JS rechnet jetzt mit unserem "eingefrorenen" staticVh, egal ob vh, svh oder dvh im Customizer steht!
          if(stickyHeightRaw.includes('vh') || stickyHeightRaw.includes('svh')) {
             targetHeight = (parseFloat(stickyHeightRaw) / 100) * staticVh;
          } else if(stickyHeightRaw.includes('px')) {
             targetHeight = parseFloat(stickyHeightRaw);
          }

          const originalWidth = tibContainer.offsetWidth;
          const originalHeight = tibContainer.offsetHeight;
          const verfuegbareBreite = tibWrapper.clientWidth;
          // Frueher wurde hier auf "nie niedriger als die Spalte breit ist"
          // hochgezogen. Das koppelt die Sticky-Hoehe an die Bildschirmbreite:
          // ab ca. 430px ueberholt die Breite die eingestellte Hoehe, und auf
          // Tablets im Hochformat verdeckt der Block dann fast den ganzen
          // Konfigurator. Die eingestellte Hoehe ist jetzt die Obergrenze;
          // schmalere Mockups werden stattdessen zentriert.
          // Auf ganze Pixel runden: sonst schwanken die Werte durch
          // Subpixel-Messungen bei jedem Durchlauf minimal und gelten
          // damit immer als "geaendert".
          targetHeight = Math.round(targetHeight);

          if (keyboardField) {
            targetHeight = Math.min(targetHeight, keyboardPreviewHeight());
          }

          // Die kleinere der beiden Skalierungen: das Motiv bleibt komplett
          // sichtbar und ragt nicht ueber die Vorschauflaeche hinaus. Die
          // Flaeche bekommt danach genau die Bildhoehe, damit darunter kein
          // ungenutzter Streifen stehen bleibt.
          const passend = (w, h) => Math.round(Math.min(targetHeight / h, verfuegbareBreite / w) * 1000) / 1000;
          const scale = passend(originalWidth, originalHeight);
          // Grundmassstab fuer Bilder, die TeeInBlue gerade erst einfuegt:
          // sie erben ihn per CSS und sitzen schon beim ersten Zeichnen richtig.
          setPlain(stickyCol, '--ext-tib-fit', String(scale));
          const bildHoehe = Math.max(1, Math.min(targetHeight, Math.round(originalHeight * scale)));
          // Alle Slides bekommen sofort ihren Massstab, damit das Bild beim
          // Wechseln des Motivs nicht erst im naechsten Durchlauf passt. Jeder
          // Slide wird dabei an seinen EIGENEN Masse angepasst - frueher galt
          // fuer alle der Massstab des sichtbaren, was bei abweichenden
          // Formaten daneben liegt. Nicht messbare Slides bekommen ersatzweise
          // den Massstab des sichtbaren; der Groessenwaechter zieht nach,
          // sobald sie ihre echten Masse haben.
          sliderMockups(stickyCol).forEach((el) => {
            const eigen = messbar(el) ? passend(el.offsetWidth, el.offsetHeight) : scale;
            loeseFremdeSkalierung(el, tibWrapper);
            setPlain(el, 'transform-origin', 'top center');
            setPlain(el, 'transform', 'scale(' + eigen + ')');
          });

          // Nachmessen statt nachrechnen: die Flaeche bekommt die Hoehe, die
          // das Bild nach der Skalierung TATSAECHLICH einnimmt. Liegt der
          // Layoutkasten des Mockups nicht buendig an der Oberkante (kommt bei
          // einem Neuaufbau von TeeInBlue vor), waere die gerechnete Hoehe zu
          // gross und genau der weisse Streifen darunter bliebe stehen.
          const gemessen = Math.round(tibContainer.getBoundingClientRect().bottom - tibWrapper.getBoundingClientRect().top);
          const hoehe = gemessen > 0 ? Math.max(1, Math.min(targetHeight, gemessen)) : bildHoehe;
          // Haken fuer die Diagnose (assets/tib-debug.js). Ohne "?tibdebug=1" nicht vorhanden.
          if (window.__tibDbgScale) window.__tibDbgScale({ ziel: targetHeight, roh: stickyHeightRaw, tastatur: !!keyboardField, basis: originalWidth + 'x' + originalHeight, breite: verfuegbareBreite, scale: scale, gemessen: gemessen, hoehe: hoehe });
          // Totband gegen Zittern um einzelne Subpixel.
          if (Math.abs(hoehe - (parseFloat(tibWrapper.style.height) || 0)) > 2) {
            setImportant(tibWrapper, 'height', hoehe + 'px');
          }
          setPlain(stickyCol, '--ext-tib-h', hoehe + 'px');
          setImportant(tibWrapper, 'min-height', '0px');
          setImportant(tibWrapper, 'max-height', targetHeight + 'px');
          setPlain(tibWrapper, 'overflow', 'hidden');
        } else {
          restoreTibSpacerHeight(tibWrapper);
          setPlain(tibWrapper, 'min-height', '');
          setPlain(tibWrapper, 'max-height', '');
          setPlain(tibWrapper, 'overflow', '');
          // Zum Schluss: ohne die Fit-Skalierung faellt das Bild auf die
          // Rendergroesse vom Seitenaufbau zurueck.
          syncTibGalleryToWidth();
        }
      } finally {
        // Von uns selbst erzeugte Records verwerfen, bevor die Sperre faellt.
        if (observer) observer.takeRecords();
        isCurrentlyScaling = false;
      }
    }

    // Getakteter Aufruf aus dem MutationObserver heraus (max. ~6/s)
    // inkl. Notbremse, falls sich TeeInBlue und wir gegenseitig hochschaukeln.
    function scheduleScale() {
      if (scaleCircuitOpen || !isMobileStickyLayout() || scaleScheduled !== null) return;
      scaleScheduled = setTimeout(() => {
        scaleScheduled = null;
        const now = Date.now();
        if (now - scaleWindowStart > 1000) { scaleWindowStart = now; scaleRunsInWindow = 0; }
        scaleRunsInWindow += 1;
        if (scaleRunsInWindow > 12) {
          scaleCircuitOpen = true;
          if (observer) observer.disconnect();
          if (groessenWaechter) groessenWaechter.disconnect();
          console.warn('[EXT] Layout-Schleife erkannt - TeeInBlue-Skalierung wurde gestoppt.');
          return;
        }
        const rect = stickyCol.getBoundingClientRect();
        startGroessenWaechter();
        if (rect.top <= 5) {
          scaleTeeInBlue(true);
        } else {
          // Steht der Nutzer oben und wechselt das Produkt, rendert TeeInBlue
          // die Galerie in seiner eigenen Pixelgroesse neu. Ohne diesen
          // Nachzug bliebe das Bild kleiner als die Spalte, bis jemand
          // scrollt - die Anpassung haengt sonst nur am Scroll-Handler.
          isCurrentlyScaling = true;
          try {
            syncTibGalleryToWidth();
          } finally {
            if (observer) observer.takeRecords();
            isCurrentlyScaling = false;
          }
        }
      }, 160);
    }

    // Der MutationObserver unten sieht nur veraenderte Attribute und Knoten.
    // Bekommt ein Mockup seine echten Masse erst spaeter (langsames Netz,
    // hastiges Scrollen direkt nach dem Laden) oder wird ein Slide sichtbar,
    // aendert sich seine Layoutgroesse ohne jede Mutation - der Massstab
    // bliebe dann falsch stehen, bis der Nutzer erneut scrollt. Genau das war
    // das gemeldete "Bild wird kleiner, darunter bleibt es weiss".
    // Rueckkopplungsfrei, weil ResizeObserver die Layoutgroesse meldet und
    // unser transform daran nichts aendert.
    let groessenWaechter = null;
    const bewachteMockups = new WeakSet();
    function startGroessenWaechter() {
      if (scaleCircuitOpen || typeof ResizeObserver === 'undefined') return;
      if (!groessenWaechter) {
        groessenWaechter = new ResizeObserver(() => {
          if (isCurrentlyScaling) return;
          scheduleScale();
        });
      }
      sliderMockups(stickyCol).forEach((m) => {
        if (bewachteMockups.has(m)) return;
        bewachteMockups.add(m);
        groessenWaechter.observe(m);
      });
    }

    const startObserver = () => {
        startGroessenWaechter();
        // Beobachtet wird die Spalte selbst, nicht die Galerie darin: baut
        // TeeInBlue beim Produktwechsel die Galerie komplett neu auf, haengt
        // ein Beobachter am alten Knoten ins Leere und meldet nie wieder
        // etwas. Die Spalte dagegen existiert vom ersten Frame an und bleibt.
        if (!observer && !scaleCircuitOpen) {
            observer = new MutationObserver(() => {
                if (isCurrentlyScaling) return;
                scheduleScale();
            });
            observer.observe(stickyCol, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class'] });
        }
    };

    function shouldShowStickyMeta(isStuck) {
      if (!isStuck || !stickyCol || !isMobileStickyLayout()) return false;
      // Im Fokus-Modus steht ausser der Vorschau nur noch das Eingabefeld -
      // Preis und Trustpilot fuellen den freien Bereich dazwischen sinnvoll.
      // Auf kleinen Geraeten bleibt dafuer aber zu wenig uebrig.
      if (keyboardField) return visibleViewportHeight() >= KEYBOARD_META_MIN_HEIGHT;
      if (!originalPriceContainer) return true;

      const stickyRect = stickyCol.getBoundingClientRect();
      const priceRect = originalPriceContainer.getBoundingClientRect();

      // Zeige die Sticky-Preisleiste erst, wenn der originale Preisbereich
      // unter die sticky Medienzone rutscht bzw. bereits darueber gescrollt ist.
      return priceRect.top < (stickyRect.bottom - 2);
    }

    function syncStickyMetaVisibility(isStuck) {
      // Nur bei echtem Zustandswechsel schreiben - vorher lief hier bei
      // JEDEM Scroll-Frame ein classList-Write und damit eine Mutation.
      const next = shouldShowStickyMeta(isStuck);
      if (next === lastMetaClass) return;
      lastMetaClass = next;
      stickyCol.classList.toggle('ext-show-sticky-meta', next);
    }

    // rAF-Gate: native "scroll"-Events koennen (v.a. auf iOS Safari) oefter
    // feuern, als der Bildschirm tatsaechlich neue Frames zeichnet. Ohne
    // Bremse liefe die Rect-Messung + scaleTeeInBlue() - und damit mehrere
    // erzwungene Layout-Reads (getComputedStyle, offsetWidth, clientWidth) -
    // mehrfach pro gezeichnetem Frame. Mit dem Gate maximal einmal pro Frame,
    // ohne Genauigkeit zu verlieren.
    //
    // BEWUSST NUR fuer "scroll": der resize-Handler weiter unten braucht
    // seine eigene Breiten-Sperre, weil die iOS-Adressleiste beim Scrollen
    // reine Hoehen-Resizes feuert. Wuerde man beide auf denselben Handler
    // legen, liefe die komplette Sticky-/Scaling-Logik dabei wieder mit.
    let stickyRafPending = false;
    function handleStickyFrame() {
      stickyRafPending = false;
      if (!isMobileStickyLayout()) {
        resetStickyState();
        return;
      }
      syncStickyRelease();
      const rect = stickyCol.getBoundingClientRect();
      // Bei offener Tastatur schiebt Safari den sichtbaren Ausschnitt nach
      // unten; der ausgleichende top-Versatz taucht hier wieder auf und darf
      // nicht als "nicht mehr geklebt" gewertet werden.
      const isStuck = (rect.top - stickyTopVersatz) <= 1;

      if (isStuck !== lastStuckClass) {
        lastStuckClass = isStuck;
        stickyCol.classList.toggle('is-stuck', isStuck);
        if (!isStuck) {
          lastMetaClass = false;
          stickyCol.classList.remove('ext-show-sticky-meta');
        }
      }

      // Auch im nicht geklebten Zustand anmelden: sonst entsteht der Waechter
      // erst, wenn die Spalte das erste Mal oben ankommt - und ein Mockup, das
      // genau dazwischen fertig rendert, bliebe unbemerkt.
      startObserver();
      if (isStuck) {
        scaleTeeInBlue(true);
      } else {
        scaleTeeInBlue(false);
      }

      syncStickyMetaVisibility(isStuck);

      // Nur den vollstaendigen Zustand merken (Bild geschrumpft UND
      // Meta-Leiste sichtbar) - genau so sieht die Spalte aus, wenn der
      // Nutzer spaeter zum Konfigurator zurueckspringt.
      if (isStuck && lastMetaClass) {
        const h = Math.round(rect.height);
        if (h > 0) lastStuckColHeight = h;
      }
    }

    window.addEventListener('scroll', () => {
      if (stickyRafPending) return;
      stickyRafPending = true;
      requestAnimationFrame(handleStickyFrame);
    }, { passive: true });

    // Der eigene Konfigurator scrollt beim Schrittwechsel selbst. Ohne diesen
    // Wert rechnet er mit einem festen Abstand und schiebt den neuen Schritt
    // hinter die klebende Vorschau.
    window.pawsStickyTopOffset = function () {
      if (!releaseBelowSel || !isMobileStickyLayout()) return 0;
      if (getComputedStyle(stickyCol).position !== 'sticky') return 0;
      const rect = stickyCol.getBoundingClientRect();
      if (rect.top <= 1) return Math.round(rect.bottom);
      return lastStuckColHeight || Math.round(rect.height);
    };

    // Nach Resize/Drehung stimmen die von TeeInBlue eingefrorenen Pixelmasse
    // nicht mehr - erst die Galerie nachziehen, dann den Sticky-Zustand neu
    // bestimmen. Die zwischengespeicherte Stuck-Hoehe gilt danach nicht mehr.
    onWidthChange(() => {
      lastStuckColHeight = 0;
      syncTibGalleryToWidth(true);
      handleStickyFrame();
      // Das Formular braucht nach einem Breitenwechsel selbst noch ein paar
      // Frames, bis seine endgueltige Hoehe steht - danach den Scrollraum
      // nachziehen.
      setTimeout(() => syncTibGalleryToWidth(true), 400);
    });

    document.addEventListener('teeinblue-component-loaded', function() {
       if (isMobileStickyLayout()) startObserver();
       handleStickyFrame();
    });

    function clearKeyboardTimers() {
      keyboardTimers.forEach(clearTimeout);
      keyboardTimers = [];
    }

    // --- FOKUS-MODUS ---
    // Halb sichtbare Formularfelder hinter dem angedockten Feld verwirren
    // mehr, als sie helfen. Waehrend getippt wird, bleiben deshalb nur die
    // Vorschau samt Preisleiste und das Eingabefeld selbst stehen. Die
    // Abdeckung beginnt unter der Sticky-Spalte, damit deren z-index und
    // das sticky-Verhalten unangetastet bleiben.
    let focusOverlay = null;
    let focusDoneBtn = null;

    function endTextEntry() {
      const feld = keyboardField || (isTextEntryField(document.activeElement) ? document.activeElement : null);
      if (feld) feld.blur();
      keyboardFocusTime = 0;
      syncKeyboardState();
    }

    function buildFocusChrome() {
      if (focusOverlay) return;
      focusOverlay = document.createElement('div');
      focusOverlay.className = 'ext-kb-overlay';
      focusOverlay.style.background = getComputedStyle(stickyCol).backgroundColor || '#fff';

      focusDoneBtn = document.createElement('button');
      focusDoneBtn.type = 'button';
      focusDoneBtn.className = 'ext-kb-done';
      focusDoneBtn.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">'
        + '<path d="M4 10.6 8 14.6 16 5.8" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>'
        + '</svg><span>Fertig</span>';

      // pointerdown statt click: der Tap darf das Feld nicht erst neu
      // fokussieren, sonst springt die Tastatur wieder auf.
      [focusOverlay, focusDoneBtn].forEach((el) => {
        el.addEventListener('pointerdown', (e) => {
          e.preventDefault();
          endTextEntry();
        });
      });

      document.body.appendChild(focusOverlay);
      document.body.appendChild(focusDoneBtn);
    }

    function setFocusMode(an) {
      if (an) buildFocusChrome();
      else if (!focusOverlay) return;
      document.body.classList.toggle('ext-kb-focus', !!an);
    }

    // Enter beendet die Eingabe - bei mehrzeiligen Feldern natuerlich nicht,
    // dort ist Enter ein Zeilenumbruch. Dafuer gibt es den Fertig-Knopf.
    // In der Aufnahmephase, weil der eigene Konfigurator Enter in Textfeldern
    // abfaengt und die Weitergabe stoppt, damit nichts abgeschickt wird.
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || !keyboardField || e.target !== keyboardField) return;
      if (keyboardField.tagName === 'TEXTAREA') return;
      e.preventDefault();
      endTextEntry();
    }, true);

    // --- FELD UEBER DER TASTATUR ANDOCKEN ---
    // Das TeeInBlue-Feld bleibt an seiner Stelle im DOM stehen - Vue darf
    // hier nicht gestoert werden - es wird nur seine Malposition verlegt.
    // Beschriftung, Zeichenzaehler und Hinweistext kommen dadurch von
    // selbst mit, ohne dass wir sie nachbauen muessen.
    let dockedField = null;
    let dockedSpacerHost = null;
    let dockedInput = null;
    // Vorfahren, die einen eigenen Stapelkontext aufmachen (TeeInBlue setzt
    // z.B. z-index:2 auf .tee-form-wrapper). Darin gilt der z-index des
    // Feldes nur noch intern - ohne Anhebung liegt es unter der Abdeckung.
    let liftedAncestors = [];

    function liftDockAncestors(feld) {
      dropDockAncestors();
      let el = feld.parentElement;
      while (el && el !== document.body) {
        const cs = getComputedStyle(el);
        const eigenerKontext = (cs.zIndex !== 'auto' && cs.position !== 'static')
          || cs.transform !== 'none' || cs.filter !== 'none'
          || cs.isolation === 'isolate' || cs.contain.includes('paint');
        if (eigenerKontext) {
          liftedAncestors.push({ el: el, alt: el.style.zIndex });
          el.style.setProperty('z-index', '61', 'important');
        }
        el = el.parentElement;
      }
    }

    function dropDockAncestors() {
      liftedAncestors.forEach((eintrag) => {
        if (eintrag.alt) eintrag.el.style.zIndex = eintrag.alt;
        else eintrag.el.style.removeProperty('z-index');
      });
      liftedAncestors = [];
    }

    function undockField() {
      if (!dockedField) return;
      dockedField.classList.remove('ext-kb-docked');
      dockedField.style.removeProperty('bottom');
      dockedField.style.removeProperty('padding-left');
      dockedField.style.removeProperty('padding-right');
      if (dockedInput) {
        dockedInput.style.removeProperty('margin-left');
        dockedInput.style.removeProperty('margin-right');
        dockedInput = null;
      }
      if (focusDoneBtn) {
        focusDoneBtn.style.removeProperty('top');
        focusDoneBtn.style.removeProperty('right');
        focusDoneBtn.style.removeProperty('height');
      }
      dropDockAncestors();
      if (dockedSpacerHost) {
        dockedSpacerHost.style.removeProperty('padding-bottom');
        dockedSpacerHost = null;
      }
      dockedField = null;
      stickyCol.style.removeProperty('top');
      setFocusMode(false);
    }

    function dockFieldAboveKeyboard() {
      if (!keyboardField || !isMobileStickyLayout() || !keyboardField.isConnected) return;
      syncStickyTopOffset();
      const feld = keyboardField.closest(DOCK_FIELD_SELECTOR) || keyboardField;
      if (dockedField && dockedField !== feld) undockField();

      if (!dockedField) {
        const hoehe = Math.round(feld.getBoundingClientRect().height);
        dockedSpacerHost = feld.parentElement;
        // Das Feld verlaesst den Fluss - der Container haelt die Hoehe,
        // damit die Seitenlaenge und die Scrollposition stabil bleiben.
        if (dockedSpacerHost && hoehe > 0) {
          dockedSpacerHost.style.setProperty('padding-bottom', hoehe + 'px', 'important');
        }
        liftDockAncestors(feld);
        dockedField = feld;
      }

      // Auf iOS bezieht sich position:fixed auf das Layout-Fenster, das bei
      // offener Tastatur seine Hoehe behaelt - die Tastaturhoehe muss deshalb
      // selbst drauf. Android verkleinert das Fenster stattdessen, dort kommt
      // hier korrekt 0 heraus.
      const vv = window.visualViewport;
      const fensterHoehe = window.innerHeight || document.documentElement.clientHeight;
      const tastaturHoehe = vv ? Math.max(0, Math.round(fensterHoehe - (vv.height + vv.offsetTop))) : 0;
      feld.classList.add('ext-kb-docked');
      feld.style.setProperty('bottom', tastaturHoehe + 'px', 'important');
      // Ohne den Rand klebt die Schrittnummer an der Bildschirmkante.
      feld.style.setProperty('padding-left', KEYBOARD_DOCK_PADDING + 'px', 'important');
      feld.style.setProperty('padding-right', KEYBOARD_DOCK_PADDING + 'px', 'important');

      // Die Abdeckung beginnt an der Unterkante der Vorschau. Die kommt aus
      // dem sichtbaren Ausschnitt, top gilt gegen das Layout-Fenster -
      // deshalb der Versatz obendrauf.
      if (focusOverlay) {
        const unterVorschau = Math.max(0, Math.round(stickyCol.getBoundingClientRect().bottom));
        focusOverlay.style.top = (unterVorschau + viewportOffsetTop()) + 'px';
      }
      // Erst hier steht die Hoehe der Leiste fest - die Vorschau darf genau
      // den Rest fuellen, gedeckelt fuer grosse Displays.
      document.documentElement.style.setProperty('--ext-kb-preview', Math.min(keyboardPreviewHeight(), KEYBOARD_PREVIEW_MAX) + 'px');
      // Der Knopf steht in der Leiste rechts neben dem Eingabefeld. Den Platz
      // dafuer gibt das Feld selbst frei - TeeInBlue setzt seine Abstaende aus
      // einem cascade layer heraus, dagegen kommt nur ein Inline-Wert an.
      const eingabe = feld.querySelector('.tee-field__input') || keyboardField;
      if (focusDoneBtn && eingabe) {
        if (dockedInput !== eingabe) {
          if (dockedInput) {
            dockedInput.style.removeProperty('margin-left');
            dockedInput.style.removeProperty('margin-right');
          }
          dockedInput = eingabe;
          dockedInput.style.removeProperty('margin-right');
        }
        // TeeInBlue haelt das Eingabefeld seitlich eingerueckt. In der Leiste
        // uebernimmt das der Rand des Feldes - so steht das Eingabefeld genau
        // unter der Schrittnummer.
        eingabe.style.setProperty('margin-left', '0px', 'important');
        const feldBox = feld.getBoundingClientRect();
        const box = eingabe.getBoundingClientRect();
        const breite = Math.round(focusDoneBtn.getBoundingClientRect().width);
        // Gleicher Abstand zur Kante wie auf der linken Seite des Feldes.
        const rand = Math.max(0, Math.round(box.left - feldBox.left));
        if (breite > 0) {
          eingabe.style.setProperty('margin-right', (breite + rand + 10) + 'px', 'important');
          focusDoneBtn.style.right = rand + 'px';
        }
        focusDoneBtn.style.top = Math.round(box.top + viewportOffsetTop()) + 'px';
        focusDoneBtn.style.height = Math.round(box.height) + 'px';
      }
    }

    // Die Vorschau aendert ihre Hoehe im Fluss, dadurch rutscht alles darunter
    // mit. Beim Verlassen haelt ein Anker die Stelle, an der der Nutzer gerade
    // liest. Beim Aktivieren bewusst nicht: dort scrollt der Browser ohnehin
    // gleich selbst zum Feld, ein eigener Sprung davor waere nur unruhig.
    function applyKeyboardMode(ankerEl, mitAnker) {
      const anker = mitAnker && ankerEl && ankerEl.isConnected ? ankerEl : null;
      const vorher = anker ? anker.getBoundingClientRect().top : null;
      stickyCol.classList.toggle('ext-keyboard-active', !!keyboardField);
      syncStickyTopOffset();
      if (keyboardField) {
        // Damit das native Scrollen zum Feld die geschrumpfte Vorschau kennt.
        const platz = keyboardPreviewHeight() + 28;
        document.documentElement.style.setProperty('--ext-kb-scroll-margin', platz + 'px');
      } else {
        document.documentElement.style.removeProperty('--ext-kb-scroll-margin');
        document.documentElement.style.removeProperty('--ext-kb-preview');
      }
      handleStickyFrame();
      if (vorher === null) return;
      const diff = anker.getBoundingClientRect().top - vorher;
      if (Math.abs(diff) > 1) window.scrollBy(0, diff);
    }

    // Die Tastatur meldet sich nicht selbst - erkennbar ist sie nur daran,
    // dass visualViewport deutlich kleiner ist als das Fenster.
    function keyboardLikelyOpen() {
      const vv = window.visualViewport;
      if (!vv || !vv.height) return true;
      return vv.height < staticVh - 120;
    }

    // Der Browser scrollt beim Fokussieren selbst zum Feld. Die Position von
    // davor gibt es nur noch beim Antippen - bei focusin ist der Sprung schon
    // passiert und wir wuerden das neue Ziel als Rueckkehrpunkt merken.
    let tapFeld = null;
    let tapTop = 0;
    let tapZeit = 0;
    document.addEventListener('pointerdown', (e) => {
      const el = e.target && e.target.closest ? e.target.closest(TEXT_FIELD_SELECTOR) : null;
      if (!el || !isMobileStickyLayout() || !isTextEntryField(el)) return;
      tapFeld = el.closest(DOCK_FIELD_SELECTOR) || el;
      tapTop = Math.round(tapFeld.getBoundingClientRect().top);
      tapZeit = Date.now();
    }, true);

    function merkeRueckkehrPunkt(eingabe) {
      const feld = eingabe.closest(DOCK_FIELD_SELECTOR) || eingabe;
      rueckkehrFeld = feld;
      // Nur beim Eintritt in den Modus: beim Weiterspringen von Feld zu Feld
      // gilt weiter die Bildschirmposition von vorher, das neue Feld landet
      // dann anschliessend genau dort.
      if (!keyboardField) {
        const ausTap = tapFeld === feld && Date.now() - tapZeit < 1500;
        rueckkehrTop = ausTap ? tapTop : Math.round(feld.getBoundingClientRect().top);
      }
    }

    function stelleRueckkehrPunktHer() {
      const feld = rueckkehrFeld;
      const ziel = rueckkehrTop;
      rueckkehrFeld = null;
      rueckkehrTimers.forEach(clearTimeout);
      rueckkehrTimers = [];
      if (!feld || !feld.isConnected) return;
      const anwenden = () => {
        if (keyboardField) return;
        const diff = Math.round(feld.getBoundingClientRect().top) - ziel;
        if (Math.abs(diff) > 1) window.scrollBy(0, diff);
      };
      anwenden();
      // iOS gibt den Platz der Tastatur erst nach dem Schliessen frei und
      // scrollt dabei noch selbst nach.
      rueckkehrTimers = [80, 260, 500].map((ms) => setTimeout(anwenden, ms));
    }

    // Einzige Stelle, die ueber den Modus entscheidet. Frueher hing er allein
    // am Fokus - beim Wegscrollen schliesst iOS aber die Tastatur, ohne ein
    // focusout zu feuern, und der Fokus-Modus blieb dauerhaft haengen.
    function syncKeyboardState() {
      const aktiv = document.activeElement;
      let naechstes = null;
      if (isMobileStickyLayout() && isTextEntryField(aktiv)) {
        if (keyboardLikelyOpen() || Date.now() - keyboardFocusTime < KEYBOARD_GRACE_MS) naechstes = aktiv;
      }
      if (naechstes === keyboardField) return;
      if (naechstes) merkeRueckkehrPunkt(naechstes);
      const anker = keyboardField || naechstes;
      const wirdBeendet = !naechstes;
      keyboardField = naechstes;
      applyKeyboardMode(anker, wirdBeendet);
      if (keyboardField) {
        setFocusMode(true);
        dockFieldAboveKeyboard();
      } else {
        undockField();
        setFocusMode(false);
        stelleRueckkehrPunktHer();
      }
    }

    // Die Tastatur schiebt sich erst nach oben, waehrend wir schon rechnen -
    // deshalb bei jeder Aenderung des sichtbaren Bereichs nachziehen.
    function onViewportChange() {
      syncKeyboardState();
      if (keyboardField) {
        // Die sichtbare Hoehe aendert sich waehrend der Eingabe auch durch
        // Vorschlagsleisten - Vorschau und Preisleiste muessen mitziehen.
        handleStickyFrame();
        dockFieldAboveKeyboard();
      }
    }

    document.addEventListener('focusin', (e) => {
      if (!isMobileStickyLayout() || !isTextEntryField(e.target)) return;
      keyboardFocusTime = Date.now();
      clearKeyboardTimers();
      syncKeyboardState();
      // Nachfassen: Android hat die Tastatur sofort, iOS meldet die neue
      // sichtbare Hoehe erst deutlich spaeter.
      keyboardTimers = [
        setTimeout(dockFieldAboveKeyboard, 150),
        setTimeout(dockFieldAboveKeyboard, 450),
        setTimeout(syncKeyboardState, KEYBOARD_GRACE_MS + 50)
      ];
    });

    document.addEventListener('focusout', (e) => {
      if (!isTextEntryField(e.target)) return;
      clearKeyboardTimers();
      // Kurz warten: beim Sprung von Feld zu Feld darf der Modus nicht flackern.
      keyboardTimers = [setTimeout(syncKeyboardState, 200)];
    });

    ['touchmove', 'wheel'].forEach((typ) => {
      window.addEventListener(typ, (e) => {
        if (!keyboardField || !e.cancelable) return;
        // Waehrend der Eingabe steht die Seite komplett still - auch ein Wisch
        // ueber der Leiste selbst wuerde Vorschau, Leiste und den von iOS
        // verschobenen Sichtbereich gegeneinander laufen lassen. Zurueck geht
        // es ueber "Fertig", Enter oder das Schliessen der Tastatur.
        e.preventDefault();
      }, { passive: false });
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewportChange);
      window.visualViewport.addEventListener('scroll', onViewportChange);
    }

    // --- NUR ZUR FEHLERSUCHE, Aufruf mit ?kbdebug=1 ---
    // Wieder entfernen, sobald das Tastaturverhalten in Safari geklaert ist.
    if (/[?&]kbdebug=1/.test(location.search)) initKeyboardDebug();

    function initKeyboardDebug() {
      const farben = document.createElement('style');
      // Einfaerbung statt Raten: rot ist die Vorschauspalte, blau die
      // Abdeckung, gruen die Preisleiste. So zeigt ein Screenshot direkt,
      // welches Element die weisse Flaeche verursacht.
      farben.textContent = '.ext-media-col{outline:2px solid red !important}'
        + '.ext-kb-overlay{background:rgba(0,110,255,.28) !important;outline:2px solid blue !important}'
        + '.ext-sticky-mobile-meta{outline:2px solid lime !important}'
        + '#teeinblue-gallery,.tee-gallery-content{outline:2px dashed orange !important}';
      document.head.appendChild(farben);

      const panel = document.createElement('pre');
      panel.style.cssText = 'position:absolute;z-index:2147483647;margin:0;padding:5px 7px;'
        + 'background:rgba(0,0,0,.85);color:#0f0;font:10px/1.3 ui-monospace,Menlo,monospace;'
        + 'white-space:pre;pointer-events:none;border-radius:6px;max-width:96vw;overflow:hidden';
      document.body.appendChild(panel);

      const start = Date.now();
      const verlauf = [];
      const box = (el) => {
        if (!el) return '-';
        const b = el.getBoundingClientRect();
        return Math.round(b.top) + '..' + Math.round(b.bottom);
      };

      function snap(quelle) {
        const vv = window.visualViewport;
        const cs = getComputedStyle(stickyCol);
        const gal = document.querySelector('#teeinblue-gallery, .tee-gallery-content');
        const meta = document.querySelector('.ext-sticky-mobile-meta');
        const ovl = document.querySelector('.ext-kb-overlay');
        const ovlAn = ovl && getComputedStyle(ovl).display !== 'none';
        const feld = document.querySelector('.tee-field.ext-kb-docked');
        const cr = stickyCol.getBoundingClientRect();

        verlauf.push(String(Date.now() - start).padStart(5) + ' ' + quelle.padEnd(9)
          + ' oT=' + (vv ? Math.round(vv.offsetTop) : '-')
          + ' vvH=' + (vv ? Math.round(vv.height) : '-')
          + ' col=' + Math.round(cr.top)
          + ' st=' + (stickyCol.classList.contains('is-stuck') ? 1 : 0));
        if (verlauf.length > 6) verlauf.shift();

        panel.textContent = [
          'win iH=' + window.innerHeight + ' sY=' + Math.round(window.scrollY)
            + ' cH=' + document.documentElement.clientHeight,
          'vv  h=' + (vv ? Math.round(vv.height) : '-')
            + ' oT=' + (vv ? Math.round(vv.offsetTop) : '-')
            + ' pT=' + (vv ? Math.round(vv.pageTop) : '-')
            + ' sc=' + (vv ? vv.scale : '-'),
          'col ' + cs.position + ' top=' + cs.top + ' r=' + box(stickyCol)
            + ' h=' + Math.round(cr.height),
          'col st=' + (stickyCol.classList.contains('is-stuck') ? 1 : 0)
            + ' kb=' + (stickyCol.classList.contains('ext-keyboard-active') ? 1 : 0)
            + ' vis=' + cs.visibility + ' op=' + cs.opacity + ' z=' + cs.zIndex,
          'gal r=' + box(gal) + (gal ? ' vis=' + getComputedStyle(gal).visibility : ''),
          'meta ' + (meta ? box(meta) + ' d=' + getComputedStyle(meta).display
            + ' o=' + getComputedStyle(meta).opacity + ' mh=' + getComputedStyle(meta).maxHeight : '-'),
          'ovl ' + (ovlAn ? 'top=' + ovl.style.top + ' r=' + box(ovl) : 'aus')
            + ' fokus=' + (document.body.classList.contains('ext-kb-focus') ? 1 : 0),
          'fld ' + (feld ? 'dock r=' + box(feld) + ' b=' + feld.style.bottom : 'frei'),
          '--- Verlauf ---',
          verlauf.join('\n')
        ].join('\n');

        // Absolut statt fest positioniert: pageTop gilt auch dann, wenn
        // Safari fixed und sticky gerade anders behandelt als erwartet.
        panel.style.top = ((vv ? vv.pageTop : window.scrollY) + 4) + 'px';
        panel.style.left = ((vv ? vv.pageLeft : 0) + 4) + 'px';
      }

      let panelRafPending = false;
      const snapBald = (quelle) => {
        if (panelRafPending) return;
        panelRafPending = true;
        requestAnimationFrame(() => { panelRafPending = false; snap(quelle); });
      };

      document.addEventListener('focusin', (e) => {
        if (!isTextEntryField(e.target)) return;
        snap('focusin');
        [120, 350, 700, 1200, 2000].forEach((ms) => setTimeout(() => snap('t+' + ms), ms));
      });
      document.addEventListener('focusout', (e) => {
        if (isTextEntryField(e.target)) setTimeout(() => snap('focusout'), 120);
      });
      window.addEventListener('scroll', () => snapBald('scroll'), { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', () => snapBald('vv-resize'));
        window.visualViewport.addEventListener('scroll', () => snapBald('vv-scroll'));
      }
      snap('start');
    }

    requestAnimationFrame(handleStickyFrame);
  }

  // --- GALLERY LOGIC ---
  if(track) {
    [...dots, ...thumbs].forEach(btn => {
      btn.addEventListener("click", (e) => {
        const index = parseInt(e.currentTarget.dataset.index);
        track.scrollTo({ left: track.clientWidth * index, behavior: "smooth" });
      });
    });
    track.addEventListener("scroll", () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, i) => {
        d.classList.toggle("active", i === index);
        if(i === index && dotsContainer) {
          d.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
      thumbs.forEach((t, i) => {
        t.classList.toggle("active", i === index);
      });
    });
  }

  // Vertrag mit snippets/paws-configurator.liquid: der Konfigurator kennt die
  // Galeriestruktur nicht und springt ueber diese ID zum passenden Farbbild.
  // Gibt true zurueck, wenn die Media-ID in der Galerie gefunden wurde.
  window.pawsShowGalleryMedia = function (mediaId, options) {
    if (!track || !mediaId) return false;
    const items = track.querySelectorAll('.ext-gallery-item');
    let index = -1;
    for (let i = 0; i < items.length; i++) {
      if (String(items[i].dataset.mediaId) === String(mediaId)) { index = i; break; }
    }
    if (index === -1) return false;
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const smooth = !(options && options.instant) && !prefersReduced;
    track.scrollTo({ left: track.clientWidth * index, behavior: smooth ? 'smooth' : 'auto' });
    return true;
  };

  // Alt-Texte der Galerie, damit der Konfigurator Farbnamen zuordnen kann.
  window.pawsGalleryMedia = function () {
    if (!track) return [];
    return [...track.querySelectorAll('.ext-gallery-item')].map(el => ({
      id: el.dataset.mediaId,
      alt: el.dataset.mediaAlt || ''
    }));
  };

  document.dispatchEvent(new CustomEvent('paws:gallery-ready'));

  // --- THUMBS LOGIC ---
  if(thumbTrack && btnPrev && btnNext) {
    function updateArrows() {
      const isStart = thumbTrack.scrollLeft <= 1;
      const isEnd = Math.ceil(thumbTrack.scrollLeft + thumbTrack.clientWidth) >= thumbTrack.scrollWidth - 1;
      if(isStart) btnPrev.classList.add('hidden'); else btnPrev.classList.remove('hidden');
      if(isEnd) btnNext.classList.add('hidden'); else btnNext.classList.remove('hidden');
    }
    btnPrev.addEventListener('click', () => { thumbTrack.scrollBy({ left: -200, behavior: 'smooth' }); });
    btnNext.addEventListener('click', () => { thumbTrack.scrollBy({ left: 200, behavior: 'smooth' }); });
    thumbTrack.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 100);
  }

  /* Variant Logic */
  // Aus drei parallelen Arrays zusammengesetzt: so muss das Template nur die
  // tatsaechlich benoetigten Variantenfelder ausgeben statt der kompletten
  // Variantenliste mit Preisen, Bildern und Metafeldern.
  const productJson = (extData.variantIds || []).map((id, i) => ({
    id: id,
    available: (extData.variantAvailable || [])[i],
    options: (extData.variantOptions || [])[i] || []
  }));
  const masterSelect = document.getElementById("MasterSelect-" + sectionId);
  const radios = document.querySelectorAll(".js-variant-radio");
  const priceContainer = originalPriceContainer;
  const mobileStickyPrice = document.getElementById("MobileStickyPrice-" + sectionId);
  const mobileStickyTrust = document.getElementById("MobileStickyTrust-" + sectionId);
  const atcBtn = document.getElementById("AddToCart-" + sectionId);

  let lastMobilePriceSignature = '';

  // Bei Produkten mit eigenem Konfigurator kommt der Preis nicht aus der
  // Variantenauswahl, sondern aus dessen laufender Berechnung.
  const mobilePriceSourceSel = mobileStickyPrice ? (mobileStickyPrice.dataset.priceSource || '') : '';
  const mobileCompareSourceSel = mobileStickyPrice ? (mobileStickyPrice.dataset.compareSource || '') : '';

  function updateMobileStickyPriceFromSelect() {
    if (!mobileStickyPrice) return;

    const currentEl = mobileStickyPrice.querySelector('.ext-sticky-price-current');
    const compareEl = mobileStickyPrice.querySelector('.ext-sticky-price-compare');
    const badgeEl = mobileStickyPrice.querySelector('.ext-sticky-price-badge');
    if (!currentEl || !compareEl || !badgeEl) return;

    let price = '';
    let compare = '';

    const src = mobilePriceSourceSel ? document.querySelector(mobilePriceSourceSel) : null;

    if (src) {
      price = (src.textContent || '').trim();
      // Vor der ersten Auswahl steht dort 0,00 EUR - bis dahin bleibt der
      // aus Liquid gerenderte Preis stehen.
      if (!price || parseFloat(price.replace(/[^0-9,.-]/g, '').replace(',', '.')) === 0) return;
      const cmp = mobileCompareSourceSel ? document.querySelector(mobileCompareSourceSel) : null;
      compare = cmp ? (cmp.textContent || '').trim() : '';
    } else {
      if (!masterSelect) return;
      const selectedOption = masterSelect.options && masterSelect.selectedIndex >= 0
        ? masterSelect.options[masterSelect.selectedIndex]
        : null;
      if (!selectedOption) return;

      price = selectedOption.dataset && selectedOption.dataset.price ? selectedOption.dataset.price : '';
      compare = selectedOption.dataset && selectedOption.dataset.compare ? selectedOption.dataset.compare : '';
    }

    const onSale = !!(compare && compare !== price);

    currentEl.textContent = price || '';
    compareEl.textContent = compare || '';
    compareEl.style.display = onSale ? 'inline' : 'none';
    badgeEl.style.display = onSale ? 'inline-flex' : 'none';

    lastMobilePriceSignature = [masterSelect ? masterSelect.value : '', price, compare, onSale ? '1' : '0'].join('|');
  }

  let trustpilotMountedInSticky = false;

  function mountTrustpilotIntoStickyMeta() {
    if (trustpilotMountedInSticky || !mobileStickyTrust) return false;
    if (window.innerWidth >= 990) return false;

    const hasTeeInBlue = !!document.querySelector('#teeinblue-form') || document.body.classList.contains('teeinblue-enabled');
    const hasStickyOhneTib = !!(stickyCol && stickyCol.dataset.releaseBelow);
    if (!hasTeeInBlue && !hasStickyOhneTib) return false;

    const originalTrustBadge = document.querySelector('body > a.pw-trust-container');
    if (!originalTrustBadge) return false;

    const scoreTextRaw = originalTrustBadge.textContent || '';
    const scoreMatch = scoreTextRaw.match(/([0-9]+[\.,][0-9]+)/);
    const score = scoreMatch ? scoreMatch[1].replace(',', '.') : '4.7';
    const countMatch = scoreTextRaw.match(/([0-9\.,]+\+)\s*Kunden/i);
    const countText = countMatch ? countMatch[1] + ' Kunden' : '24.000+ Kunden';

    const compactLink = document.createElement('a');
    compactLink.className = 'ext-sticky-tp-inline';
    compactLink.href = originalTrustBadge.getAttribute('href') || 'https://de.trustpilot.com/review/pawslife.de';
    compactLink.target = '_blank';
    compactLink.rel = 'noopener';
    compactLink.setAttribute('aria-label', 'Trustpilot Bewertung ' + score + ' von 5');

    compactLink.innerHTML =
      '<span class="ext-sticky-tp-main">' +
        '<span class="ext-sticky-tp-score">' + score + '</span>' +
        '<svg class="ext-sticky-tp-star" viewBox="0 0 32 32" aria-hidden="true"><path d="M32 12.408l-12.256-.096L16 0l-3.744 12.312H0l9.92 7.176-3.72 12.12 9.8-7.448 9.8 7.448-3.72-12.12z"></path></svg>' +
        '<span class="ext-sticky-tp-brand">Trustpilot</span>' +
      '</span>' +
      '<span class="ext-sticky-tp-count">' + countText + '</span>';

    mobileStickyTrust.innerHTML = '';
    mobileStickyTrust.appendChild(compactLink);
    mobileStickyTrust.classList.remove('is-fallback-active');

    document.body.classList.add('ext-tib-mobile-trustpilot-ready');
    trustpilotMountedInSticky = true;
    return true;
  }

  if(radios.length > 0) {
    function updateVariant() {
      const fieldsets = document.querySelectorAll('.ext-variant-fieldset');
      const selectedOptions = Array.from(fieldsets).map(fs => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      fieldsets.forEach(fs => {
        const checked = fs.querySelector('input:checked');
        const labelSpan = fs.querySelector('.js-option-val');
        if(checked && labelSpan) labelSpan.textContent = checked.value;
      });
      const matchedVariant = productJson.find(variant => {
        return variant.options.every((val, index) => val === selectedOptions[index]);
      });
      if(matchedVariant) {
        masterSelect.value = matchedVariant.id;
        if(priceContainer) {
          const optionEl = masterSelect.querySelector(`option[value="${matchedVariant.id}"]`);
          if(optionEl) {
             let html = `<span class="price-item">${optionEl.dataset.price}</span>`;
             if(optionEl.dataset.compare && optionEl.dataset.compare !== optionEl.dataset.price) {
               html += `<span class="ext-p-compare">${optionEl.dataset.compare}</span> <span class="ext-p-badge">Sale</span>`;
             }
             priceContainer.innerHTML = html;
          }
        }
        updateMobileStickyPriceFromSelect();
        if(matchedVariant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = "In den Warenkorb";
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = "Ausverkauft";
        }
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = "Nicht verfügbar";
      }
    }
    radios.forEach(r => r.addEventListener('change', updateVariant));
  }

  if (masterSelect) {
    masterSelect.addEventListener('change', updateMobileStickyPriceFromSelect);
    masterSelect.addEventListener('input', updateMobileStickyPriceFromSelect);

    // TeeInBlue aendert die Variantenauswahl teils ohne natives change-Event.
    setInterval(() => {
      if (window.innerWidth >= 990) return;
      const selectedOption = masterSelect.options && masterSelect.selectedIndex >= 0
        ? masterSelect.options[masterSelect.selectedIndex]
        : null;
      if (!selectedOption) return;

      const price = selectedOption.dataset && selectedOption.dataset.price ? selectedOption.dataset.price : '';
      const compare = selectedOption.dataset && selectedOption.dataset.compare ? selectedOption.dataset.compare : '';
      const signature = [masterSelect.value, price, compare, (compare && compare !== price) ? '1' : '0'].join('|');

      if (signature !== lastMobilePriceSignature) {
        updateMobileStickyPriceFromSelect();
      }
    }, 350);
  }

  // Trustpilot mobil vom linken Fix-Badge in die rechte Sticky-Meta-Slot verschieben.
  mountTrustpilotIntoStickyMeta();
  let trustpilotMountTries = 0;
  const trustpilotMountTimer = setInterval(() => {
    trustpilotMountTries += 1;
    if (mountTrustpilotIntoStickyMeta() || trustpilotMountTries > 30) {
      clearInterval(trustpilotMountTimer);
    }
  }, 300);

  // Unter 990px wurde das Badge bewusst nicht montiert - beim Wechsel ueber
  // den Breakpoint (Fenstergroesse, Drehung) nachholen.
  onWidthChange(function () { mountTrustpilotIntoStickyMeta(); });

  updateMobileStickyPriceFromSelect();

  if (mobilePriceSourceSel && 'MutationObserver' in window) {
    const mobilePriceSrc = document.querySelector(mobilePriceSourceSel);
    if (mobilePriceSrc) {
      new MutationObserver(updateMobileStickyPriceFromSelect)
        .observe(mobilePriceSrc, { childList: true, characterData: true, subtree: true });
    }
  }

    // TeeInBlue-Styles koennen Swatches spaet nachladen/ueberschreiben.
    normalizeNonFrameColorSwatches();

    const tibForm = document.getElementById('teeinblue-form');
    if (tibForm) {
      const swatchMutationObserver = new MutationObserver((mutations) => {
        const affectsColorSwatches = mutations.some((mutation) => {
          if (mutation.type !== 'childList') return false;

          const changedNodes = [
            ...Array.from(mutation.addedNodes || []),
            ...Array.from(mutation.removedNodes || [])
          ];

          return changedNodes.some((node) => {
            if (!(node instanceof Element)) return false;
            if (node.matches('.tee-option--color, .tee-radio, .tee-radio-label, .tee-swatch--color')) return true;
            return !!node.querySelector('.tee-option--color, .tee-radio, .tee-radio-label, .tee-swatch--color');
          });
        });

        if (affectsColorSwatches) {
          scheduleNormalizeNonFrameColorSwatchesBurst();
          return;
        }

        const hasStructuralChanges = mutations.some((mutation) => {
          if (mutation.type !== 'childList') return false;
          return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
        });
        if (hasStructuralChanges) {
          scheduleNormalizeNonFrameColorSwatches();
        }
      });

      swatchMutationObserver.observe(tibForm, {
        childList: true,
        subtree: true
      });

      // Bei schnellen TeeInBlue-Optionwechseln kann die Farbgruppe neu gerendert werden.
      // Der Burst setzt den Kreis-Look sofort erneut, bevor Zwischenzustaende sichtbar sind.
      tibForm.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const hit = target.closest('.tee-option .tee-radio, .tee-option .tee-radio-label');
        if (hit && hit.closest('.custom-frame-wrapper')) return;
        if (hit) {
          scheduleNormalizeNonFrameColorSwatchesBurst();
        }
      }, true);

      tibForm.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('.custom-frame-wrapper')) return;
        if (target.matches('.tee-option input[type="radio"], .tee-option input[type="checkbox"], .tee-option select')) {
          scheduleNormalizeNonFrameColorSwatchesBurst();
        }
      }, true);
    }

    scheduleNormalizeNonFrameColorSwatchesBurst();
  let swatchNormalizeTries = 0;
  const swatchNormalizeTimer = setInterval(() => {
    swatchNormalizeTries += 1;
    normalizeNonFrameColorSwatches();
    if (swatchNormalizeTries > 30) clearInterval(swatchNormalizeTimer);
  }, 300);

  /* =========================================
     STICKY ADD-TO-CART LEISTE
     ========================================= */
  (function initStickyAtc() {
    const bar = document.getElementById('StickyAtc-' + sectionId);
    const mainContainer = document.getElementById('MainProduct-' + sectionId);
    if (!bar || !mainContainer) return;

    const btn = document.getElementById('StickyAtcBtn-' + sectionId);
    const trustSlot = document.getElementById('StickyAtcTrust-' + sectionId);
    const priceSlot = document.getElementById('StickyAtcPrice-' + sectionId);

    // Gesetzt bei Produkten mit dem eigenen Konfigurator: die springen nicht
    // in den TeeInBlue-Ablauf, sondern an dessen Anfang zurueck.
    const scrollTargetSel = bar.dataset.scrollTarget || '';
    const priceSourceSel = bar.dataset.priceSource || '';
    const compareSourceSel = bar.dataset.compareSource || '';

    let isVisible = false;

    function setVisible(next) {
      if (next === isVisible) return;
      isVisible = next;
      bar.classList.toggle('is-visible', next);
      bar.setAttribute('aria-hidden', next ? 'false' : 'true');
    }

    // --- Sichtbarkeit: Leiste erscheint, sobald der Hauptcontainer
    // (Galerie + Produktformular) komplett nach oben aus dem Viewport ist.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // Nur nach oben ausgetreten -> anzeigen. Unten (noch nicht erreicht) -> aus.
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          setVisible(scrolledPast);
        });
      }, { threshold: 0 }).observe(mainContainer);
    } else {
      // Fallback ohne IntersectionObserver: rAF-getakteter Scroll-Handler.
      let pending = false;
      const check = () => {
        pending = false;
        setVisible(mainContainer.getBoundingClientRect().bottom <= 0);
      };
      window.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(check);
      }, { passive: true });
      check();
    }

    // --- Klick: zurueck zum Konfigurator scrollen, und zwar so, dass
    // Schritt 1 direkt UNTER der sticky Medienspalte steht.
    //
    // Ein simples scrollIntoView() reicht hier nicht: auf Mobil klebt die
    // Medienspalte (geschrumpftes Bild + Preis-/Trust-Leiste) oben am
    // Viewport und verdeckt rund 400 px. Schritt 1 wuerde also exakt
    // dahinter geparkt. Erschwerend kommt hinzu, dass die Spalte im Moment
    // des Klicks noch gar nicht klebt - ihre endgueltige Hoehe entsteht
    // erst waehrend des Scrollens (Klasse is-stuck + scaleTeeInBlue mit
    // 0.2s-Transition). Die Zielposition laesst sich vorab also nur
    // schaetzen. Darum: mit der zuletzt gemessenen Stuck-Hoehe vorhersagen,
    // smooth hinscrollen und danach still nachjustieren.
    const STEP_GAP = 12;
    // Mindestluft ueber dem eigenen Konfigurator, damit er nicht buendig
    // am oberen Bildschirmrand klebt.
    const CENTER_MIN_GAP = 24;

    // Schritt 1 ist das erste Element in Dokumentreihenfolge, das den
    // CSS-Counter "tibStep" hochzaehlt - also die erste sichtbar
    // nummerierte Ueberschrift.
    //
    // WICHTIG: Der Counter laeuft NICHT nur innerhalb von #teeFormInputs.
    // Produkt-, Groessen- und Rahmenauswahl liegen als .tee-option__title
    // AUSSERHALB davon und tragen je nach Produkt die Nummern 1 und 2
    // (z. B. "Minimalistisches Tierportrait": 1 = Verfuegbare Produkte,
    // 2 = Groesse, erst 3 = erstes Feld in #teeFormInputs). Wer nur
    // #teeFormInputs durchsucht, springt dort faelschlich auf Schritt 3.
    //
    // Statt die CSS-Regeln in JS nachzubauen, fragen wir den berechneten
    // Stil: was das Stylesheet tatsaechlich nummeriert, zaehlt.
    function getStepOneTarget() {
      if (scrollTargetSel) return document.querySelector(scrollTargetSel) || mainContainer;

      const form = document.getElementById('teeinblue-form');
      if (form) {
        const heads = form.querySelectorAll('.tee-option__title, .tee-field__heading');
        for (let i = 0; i < heads.length; i++) {
          const head = heads[i];
          const cs = getComputedStyle(head);
          if (cs.display === 'none' || cs.visibility === 'hidden') continue;
          if ((cs.counterIncrement || '').indexOf('tibStep') === -1) continue;

          const headRect = head.getBoundingClientRect();
          if (headRect.height <= 0) continue;

          // Moeglichst den ganzen Schritt zeigen, nicht nur die Ueberschrift.
          // Aber nur, wenn der Container wirklich zu diesem Schritt gehoert -
          // ein weit darueber beginnender Sammel-Wrapper wuerde sonst viel
          // zu hoch ansetzen.
          const box = head.closest('.tee-option, .tee-field');
          if (box && (headRect.top - box.getBoundingClientRect().top) <= 60) return box;
          return head;
        }
      }

      return document.querySelector('#teeFormInputs .tee-field:not(.sr-only)')
        || document.getElementById('teeFormInputs')
        || document.getElementById('teeinblue-form')
        || document.querySelector('.ext-info-col')
        || mainContainer;
    }

    // Wie viel Platz belegt die Medienspalte gerade oben am Viewport?
    // Nur relevant, solange sie tatsaechlich sticky ist und oben klebt -
    // auf Desktop bzw. ohne Sticky-Tag ist der Wert 0.
    function stickyBottomNow() {
      if (!stickyCol) return 0;
      if (getComputedStyle(stickyCol).position !== 'sticky') return 0;
      const r = stickyCol.getBoundingClientRect();
      return r.top <= 1 ? r.bottom : 0;
    }

    // Beim Hochscrollen blendet das Theme seinen Header wieder ein. Ohne
    // diesen Abstand landet der Kopf des Konfigurators dahinter.
    function fixedHeaderBottom() {
      if (!scrollTargetSel) return 0;
      let bottom = 0;
      document.querySelectorAll('.hdt-sticky-header, [id^="shopify-section-header"]').forEach((el) => {
        const cs = getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        const r = el.getBoundingClientRect();
        if (r.height > 0 && r.top <= 1 && r.bottom > bottom) bottom = r.bottom;
      });
      return bottom;
    }

    function topOverlayBottom() {
      return Math.max(stickyBottomNow(), fixedHeaderBottom());
    }

    function alignDelta(target) {
      return Math.round(target.getBoundingClientRect().top - topOverlayBottom() - STEP_GAP);
    }

    function reduceMotionNow() {
      return !!(window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    // Nachjustierung: wartet, bis der Smooth-Scroll steht, misst dann die
    // echte Verdeckung und korrigiert. Laeuft mehrfach, weil sich die
    // Spaltenhoehe waehrend der Skalierungs-Transition noch aendert.
    function settleOnStepOne(target) {
      let frames = 0;
      let idleFrames = 0;
      let corrections = 0;
      let lastY = -1;
      let lastAbsDelta = Infinity;
      let aborted = false;

      // Greift der Nutzer selbst ein, halten wir uns sofort raus.
      const abort = () => { aborted = true; };
      window.addEventListener('wheel', abort, { passive: true, once: true });
      window.addEventListener('touchstart', abort, { passive: true, once: true });
      window.addEventListener('keydown', abort, { once: true });

      const cleanup = () => {
        window.removeEventListener('wheel', abort);
        window.removeEventListener('touchstart', abort);
        window.removeEventListener('keydown', abort);
      };

      const tick = () => {
        if (aborted) return cleanup();
        frames++;

        const y = Math.round(window.scrollY);
        idleFrames = (y === lastY) ? idleFrames + 1 : 0;
        lastY = y;

        // Erst eingreifen, wenn die Seite drei Frames lang still steht.
        if (idleFrames >= 3) {
          const delta = alignDelta(target);
          const absDelta = Math.abs(delta);

          // Sitzt es? Fertig.
          if (absDelta <= 3) return cleanup();

          // Reissleine: mehr als 12 Anlaeufe deuten auf ein Layout hin, das
          // sich nicht beruhigt. Der Spielraum muss hier grosszuegig sein,
          // weil das Ziel waehrend des Scrollens wandert: sobald die Spalte
          // klebt, schrumpft das TIB-Bild und alles darunter rutscht hoch
          // (bei "Minimalistisches Tierportrait" um rund 970 px).
          if (corrections >= 12) return cleanup();

          // Oszillationsschutz: wird es deutlich schlechter statt besser,
          // pendeln wir zwischen zwei Layout-Zustaenden. Dann lieber stehen
          // bleiben, als den Nutzer weiter herumzuschieben.
          if (corrections > 0 && absDelta > lastAbsDelta * 1.5) return cleanup();
          lastAbsDelta = absDelta;

          corrections++;
          // Groessere Korrekturen weich fahren, damit kein sichtbarer Ruck
          // entsteht (passiert vor allem, wenn der Nutzer von ganz unten
          // springt und die gecachte Stuck-Hoehe noch ungenau war).
          // Kleine Reste hart setzen - die sieht ohnehin niemand.
          if (absDelta > 24 && !reduceMotionNow()) {
            window.scrollBy({ top: delta, behavior: 'smooth' });
          } else {
            window.scrollBy(0, delta);
          }
          idleFrames = 0;
        }

        // Harte Obergrenze (~6 s), damit hier nie eine Dauerschleife bleibt.
        if (frames < 360) requestAnimationFrame(tick);
        else cleanup();
      };

      requestAnimationFrame(tick);
    }

    if (btn) {
      btn.addEventListener('click', () => {
        const target = getStepOneTarget();
        if (!target) return;

        // Eigener Konfigurator: das Ziel bewegt sich beim Scrollen nicht,
        // also reicht ein einziger Scroll ohne Nachjustierung - sonst faehrt
        // die Seite erst zu weit hoch und danach sichtbar wieder zurueck.
        if (scrollTargetSel) {
          const rect = target.getBoundingClientRect();
          const headroom = fixedHeaderBottom();
          const free = window.innerHeight - headroom;
          // Passt der Konfigurator ins Bild, wird er mittig gesetzt.
          const gap = Math.max(CENTER_MIN_GAP, Math.round((free - rect.height) / 2));
          const centered = Math.max(0, rect.top + window.scrollY - headroom - gap);

          window.scrollTo({ top: centered, behavior: reduceMotionNow() ? 'auto' : 'smooth' });
          return;
        }

        // Vorhersage: gecachte Stuck-Hoehe bevorzugen, sonst der aktuelle
        // Wert (0, falls die Spalte gar nicht sticky ist - dann landet das
        // Ziel schlicht oben am Viewport, was auf Desktop korrekt ist).
        const offset = (lastStuckColHeight || topOverlayBottom()) + STEP_GAP;
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);

        window.scrollTo({ top: top, behavior: reduceMotionNow() ? 'auto' : 'smooth' });
        settleOnStepOne(target);
      });
    }

    // --- Preis mit der Variantenauswahl synchron halten.
    function syncStickyAtcPrice() {
      if (!priceSlot) return;

      const currentEl = priceSlot.querySelector('.ext-sticky-atc__price-current');
      const compareEl = priceSlot.querySelector('.ext-sticky-atc__price-compare');
      if (!currentEl || !compareEl) return;

      let price = '';
      let compare = '';

      if (priceSourceSel) {
        const src = document.querySelector(priceSourceSel);
        if (!src) return;
        price = (src.textContent || '').trim();
        // Der Konfigurator startet bei 0,00 EUR und rechnet erst nach der
        // ersten Auswahl - bis dahin bleibt der Preis aus Liquid stehen.
        if (!price || parseFloat(price.replace(/[^0-9,.-]/g, '').replace(',', '.')) === 0) return;
        const cmp = compareSourceSel ? document.querySelector(compareSourceSel) : null;
        compare = cmp ? (cmp.textContent || '').trim() : '';
      } else {
        if (!masterSelect) return;
        const opt = masterSelect.options && masterSelect.selectedIndex >= 0
          ? masterSelect.options[masterSelect.selectedIndex]
          : null;
        if (!opt || !opt.dataset) return;
        price = opt.dataset.price || '';
        compare = opt.dataset.compare || '';
      }

      if (currentEl.textContent !== price) currentEl.textContent = price;
      const showCompare = !!(compare && compare !== price);
      compareEl.textContent = showCompare ? compare : '';
      compareEl.style.display = showCompare ? 'inline' : 'none';
    }

    syncStickyAtcPrice();
    if (masterSelect) masterSelect.addEventListener('change', syncStickyAtcPrice);

    if (priceSourceSel && 'MutationObserver' in window) {
      const priceSrc = document.querySelector(priceSourceSel);
      if (priceSrc) {
        new MutationObserver(syncStickyAtcPrice)
          .observe(priceSrc, { childList: true, characterData: true, subtree: true });
      }
    }

    // --- Trustpilot-Badge aus dem globalen Element ableiten.
    // Das Original wird von mountTrustpilotIntoStickyMeta() ggf. ausgeblendet,
    // bleibt aber im DOM - der Textinhalt ist daher weiter lesbar.
    let trustDone = false;
    function mountStickyAtcTrust() {
      if (trustDone || !trustSlot) return true;

      const original = document.querySelector('body > a.pw-trust-container');
      if (!original) return false;

      const raw = original.textContent || '';
      const scoreMatch = raw.match(/([0-9]+[\.,][0-9]+)/);
      const score = scoreMatch ? scoreMatch[1].replace(',', '.') : '4.7';
      const countMatch = raw.match(/([0-9\.,]+\+)\s*Kunden/i);
      const countText = countMatch ? countMatch[1] + ' Kunden' : '24.000+ Kunden';

      const link = document.createElement('a');
      link.className = 'ext-sticky-atc-tp';
      link.href = original.getAttribute('href') || 'https://de.trustpilot.com/review/pawslife.de';
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'Trustpilot Bewertung ' + score + ' von 5');
      link.innerHTML =
        '<span class="ext-sticky-atc-tp-score">' + score + '</span>' +
        '<svg class="ext-sticky-atc-tp-star" viewBox="0 0 32 32" aria-hidden="true"><path d="M32 12.408l-12.256-.096L16 0l-3.744 12.312H0l9.92 7.176-3.72 12.12 9.8-7.448 9.8 7.448-3.72-12.12z"></path></svg>' +
        '<span class="ext-sticky-atc-tp-brand">Trustpilot</span>' +
        '<span class="ext-sticky-atc-tp-count">' + countText + '</span>';

      trustSlot.innerHTML = '';
      trustSlot.appendChild(link);
      trustDone = true;
      return true;
    }

    if (!mountStickyAtcTrust()) {
      // Das Badge wird von einer App spaet nachgeladen - begrenzt nachfassen.
      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (mountStickyAtcTrust() || tries > 40) clearInterval(timer);
      }, 300);
    }
  })();
});
